import { IHeader } from "ag-grid-community/main";
import Hyperlink from "../../common/components/AgGrid/HyperlinkRender";
import {
  BoardIds,
  FilterIdentifier,
  FilterUserSelection,
} from "../../common/generic/generic-filters-boards-attributes";
import { BuildUrlForHyperlinkInGrid } from "../../common/generic/generic-helper";
import {
  IFilterColumnsByRole,
  IGenericAggregateResponse,
  IGenericHyperlinkFilter,
} from "../../common/generic/generic-types";
import { SCProfileDictionary } from "../../common/salescredit/salescredit-profile-dictionary";
import {
  ICprSalescreditRevenueKpi,
  ICprSalesCreditSearchCriteria,
  INbiSalescreditResponse,
} from "../../common/utils/types";

const client = "client";
export function getMapping(
  data: IGenericAggregateResponse,
  profile: string,
  level: any,
  clientLevelId: any
): IFilterColumnsByRole | undefined {
  if (!data.aggregates || data.aggregates.length === 0) {
    return undefined;
  }

  const pd = new SCProfileDictionary();
  const profileKpis = pd.GetGridFields(profile);
  const rows: any[] = [];
  const dateForFilter = [];

  dateForFilter.push(data.request ? data.request.date : "");
  for (const item of data.aggregates) {
    const clientName = item.dimensionAttributeValues[level];
    const clientId = item.dimensionAttributeValues[clientLevelId];
    const clientIdForFilter = [];
    clientIdForFilter.push(clientId);
    const hFilterTypes: any = [];
    hFilterTypes.push({
      filter_id: FilterIdentifier.client_selector,
      id: FilterUserSelection.client_selector,
      value: clientIdForFilter,
    });
    hFilterTypes.push({
      filter_id: FilterIdentifier.asOfDate,
      id: FilterUserSelection.asOfDate,
      value: dateForFilter,
    });
    const hFilter: IGenericHyperlinkFilter = {
      board_id: BoardIds.Client_Snapshot,
      filter: hFilterTypes,
    };
    const row: { [field: string]: string | number } = {};

    row[client] = clientName;
    row[clientLevelId] = clientId;
    row.hlink = BuildUrlForHyperlinkInGrid(hFilter);
    for (const kpiRaw of profileKpis) {
      row[kpiRaw.Kpi] = item.indicatorKpiValues[kpiRaw.Kpi];
    }
    rows.push(row);
  }
  return { Headers: buildHeaders(profile, level), Rows: rows };
}

export function buildHeaders(profile: string, level: any) {
  const headers: IHeader[] = [
    {
      cellRendererFramework: Hyperlink,
      field: client,
      headerName:
        level === "client_lename"
          ? "Client (LE level)"
          : "Client (Group level)",
      suppressSizeToFit: true,
      width: 250,
    },
  ];

  const pd = new SCProfileDictionary();
  const headerKpis = pd.GetGridFields(profile);

  for (const kpiRaw of headerKpis) {
    headers.push(kpiRaw.HeaderFormat);
  }
  return headers;
}
